import { render } from "./doughnutChart.vue?vue&type=template&id=2c95b972&scoped=true&ts=true"
import script from "./doughnutChart.vue?vue&type=script&lang=ts"
export * from "./doughnutChart.vue?vue&type=script&lang=ts"

import "./doughnutChart.vue?vue&type=style&index=0&id=2c95b972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c95b972"]])

export default __exports__